import ContentOverlay from "../components/content_overlay";
import "./webinar.css";

function WebinarsPage() {
  return (
    <ContentOverlay
      heading={<h2 style={{ textAlign: "center" }}>Webinars</h2>}
      text_content={
        <p style={{ fontSize: "0.99em" }}>
          <br />
          <table className="container">
            <tr>
              <td style={{ textAlign: "center" }}>
                <b>Webinar Title and Speaker</b>
              </td>
              <td style={{ textAlign: "center" }}>
                <b> Inviation and link to the Webinar</b>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                1. LiFE (Lifestyle for Environment): Concepts - Dr Anandi
                Subramanian & LiFE - Curriculum (NEP) and behavioral changes in
                students – Mr. Johny Biosphere
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/1.png"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
                <a href="https://www.youtube.com/live/RXJmt5MVfCg?si=fWzDi4gR60Rcz8ZT">
                  https://www.youtube.com/live/RXJmt5MVfCg?si=fWzDi4gR60Rcz8ZT
                </a>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                2. LiFE: Innovative Ideas for Rainwater Harvesting – Mr. AR
                Shivakumar
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/2.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
                <a href="https://www.youtube.com/live/6hIsjBeHxzk?si=aiMILRuWfxK-KZe">
                  https://www.youtube.com/live/6hIsjBeHxzk?si=aiMILRuWfxK-KZe
                </a>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                3. Mangroves for LiFE – Dr. K Kathiresan
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/3.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
                <a href="https://www.youtube.com/live/5D88UEvGabA?si=bMwbRb9NNvMaq8v8">
                  https://www.youtube.com/live/5D88UEvGabA?si=bMwbRb9NNvMaq8v8
                </a>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                4. Waste to Wealth – Dr. Durga Madhab Mahapatra
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/4.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
                <a href="https://www.youtube.com/watch?v=6hIsjBeHxzk&list=PLn5TEEnUiGWQ8c0FxKI46TKKDBle6fTMA&index=29">
                  https://www.youtube.com/watch?v=6hIsjBeHxzk&list=PLn5TEEnUiGWQ8c0FxKI46TKKDBle6fTMA&index=29
                </a>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                5. The Science of Social Change through Energy Access – Dr.
                Harish Hande
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/5.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
                <a href="https://youtu.be/9MJy0iElgmg?si=ezGGPTQWg9xw6Pd-">
                  https://youtu.be/9MJy0iElgmg?si=ezGGPTQWg9xw6Pd-
                </a>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                6. The art of Organic waste to Energy ~ a sustainable lifestyle
                – Dr Vaman Acharya
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/6.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
                <a href="https://youtu.be/bmyjkf6Ijm0?si=ztxkeyNU3dyaU2H3">
                  https://youtu.be/bmyjkf6Ijm0?si=ztxkeyNU3dyaU2H3
                </a>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                7. Innovate & Decentralized solutions for a sustainable
                lifestyle – Dr. Tejaswini Ananth Kumar
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/7.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
                <a href="https://www.youtube.com/live/07Y1oSCXh0Y?si=4R38geDusxI-ZlnQ">
                  https://www.youtube.com/live/07Y1oSCXh0Y?si=4R38geDusxI-ZlnQ
                </a>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                8. Namma Gubbachi namma makkalu – Practice Lifestyle for
                Environment – Dr HS Sudhira
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/8.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
                <a href="https://youtu.be/1zygVOAeu_k?si=R2EZpekQm_rq-mje">
                  https://youtu.be/1zygVOAeu_k?si=R2EZpekQm_rq-mje
                </a>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                9. Fundamentals of policy analysis, EIRR & cost benefit analysis
                covering aspects of shadow pricing – Mr. Amaresh G Nashi
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/9.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
                <a
                  href="https://www.youtube.com/watch?v=6hIsjBeHxzk&list=PLn5TEEnUiGWQ8c0FxKI46TKKDBle6fTMA&index=29
 
"
                >
                  https://www.youtube.com/watch?v=6hIsjBeHxzk&list=PLn5TEEnUiGWQ8c0FxKI46TKKDBle6fTMA&index=29
                </a>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                10. Tiger Conservation- Challenges and Opportunities – Mr.
                Praveen Bhargav
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/10.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
                <a
                  href="https://www.youtube.com/live/IHoqcYUSVJU?si=DjKli1bK-5C9y1ZB
 
"
                >
                  https://www.youtube.com/live/IHoqcYUSVJU?si=DjKli1bK-5C9y1ZB
                </a>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                11. Decentralised Waste Management – Issues and Challenges – Dr
                Ellen & Soumya Raghavan
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/11.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
                <a
                  href="https://www.youtube.com/live/s1vHi-EVGo8?si=gRp_t4DpVl_o4mnn
 
"
                >
                  https://www.youtube.com/live/s1vHi-EVGo8?si=gRp_t4DpVl_o4mnn
                </a>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                12. Art of Waste Management: Organic waste to wealth through
                innovative bio soldiers – Mr Srikanth BH
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/12.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
                <a
                  href="https://youtu.be/w4WKc0xkO8I?si=U4daD_yu8xIl-1UD
 
"
                >
                  https://youtu.be/w4WKc0xkO8I?si=U4daD_yu8xIl-1UD
                </a>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                13. Role of Birds in Ecosystem Conservation – Mr. Vrijulal MV
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/13.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
                <a
                  href="https://www.youtube.com/live/BViL6kqW3QE?si=43PClrOd5VKmKzI-
 
"
                >
                  https://www.youtube.com/live/BViL6kqW3QE?si=43PClrOd5VKmKzI-
                </a>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                14. Role of Diatoms in securing energy for future - Dr Karthik
                Balasubramanian
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/14.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
                <a
                  href="https://www.youtube.com/live/i2i4rMVTet0?si=GRYZ6w7xsp16VKum
 
"
                >
                  https://www.youtube.com/live/i2i4rMVTet0?si=GRYZ6w7xsp16VKum
                </a>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                15. Ozone Day: Can individual lifestyle change contribute to
                environmental conservation
              </td>
              <td style={{ textAlign: "center" }}>
                <a
                  href="https://youtu.be/I6kY7cBk8m0?si=jgdoXWzO6NCd7STC
 
"
                >
                  https://youtu.be/I6kY7cBk8m0?si=jgdoXWzO6NCd7STC
                </a>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                16. Workshop on (hybrid mode) Earth Observation and Digital
                Transformation - Prof. Jagannath Aryal; Rajesh Singh Rana; Buwan
                Chandra; Paras Negi
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/16.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
                <a
                  href="https://www.youtube.com/live/cazsXBx31B8?si=6VypS145cVt50lxJ
 
"
                >
                  https://www.youtube.com/live/cazsXBx31B8?si=6VypS145cVt50lxJ
                </a>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                17. Role of Mangrove ecosystem in conservation of biodiversity-
                Dr Goldin Quadros, SACON
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/17.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
                <a
                  href="https://www.youtube.com/live/jniduLNRJco?si=DUtxRbtmG7_rmyJD
 
"
                >
                  https://www.youtube.com/live/jniduLNRJco?si=DUtxRbtmG7_rmyJD
                </a>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                18. Wetlands Wise Use and Mission Life -Dr. Ritesh Kumar
                Wetlands International South Asia
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/18.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
                <a
                  href="https://www.youtube.com/live/jniduLNRJco?si=DUtxRbtmG7_rmyJD
https://www.youtube.com/live/Nin8il-6Q3M?si=AUd5W0u5Pd249z3S

 
"
                >
                  hhttps://www.youtube.com/live/jniduLNRJco?si=DUtxRbtmG7_rmyJD
                  https://www.youtube.com/live/Nin8il-6Q3M?si=AUd5W0u5Pd249z3S
                </a>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                19. Environmental Management – Rajasree V R
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/19.png"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
                <a
                  href="https://youtu.be/MLoXiG1qXH0?si=p9eJ7W-Q2Tyeqvj7

 
"
                >
                  https://youtu.be/MLoXiG1qXH0?si=p9eJ7W-Q2Tyeqvj7
                </a>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                20. Environmental Literacy – Rajasree V R
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/20.png"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
                <a
                  href="https://youtu.be/zjbEHzSwC60?si=RJkVknzUiE5uhBeC

 
"
                >
                  https://youtu.be/zjbEHzSwC60?si=RJkVknzUiE5uhBeC
                </a>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                21.Origin of Environmental Science from Vedas- Dr Anil Gupta
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/21.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
                <a
                  href="https://youtu.be/6cJkyD07Koo?si=TeJSHlTdmPyAiCit

 
"
                >
                  https://youtu.be/6cJkyD07Koo?si=TeJSHlTdmPyAiCit
                </a>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                22. E-workshop, World Environment Day Title: Urban & Water
                Issues Time: 1.45 to 3:00 pm, Date: 30/05/24 Link for the
                meeting:
                <a href="https://bit.ly/3yFmQXT">https://bit.ly/3yFmQXT</a>
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/22.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                23. e-workshop - World Environment Day: Webinar on Environmental
                Design for Sustainability 11 am-12 p.m. on 05th June 2024.
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/23.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
                <a href="https://bit.ly/4c7GGJL">https://bit.ly/4c7GGJL</a>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                24. World Mangroves day Workshop: Ecological services & Societal
                benefits of Mangroves, Walking trees 26 July 2024
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/24.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                25. Topic: LiFE Webinar Series | Policy and legal aspects of
                Environment Management | By Mr. Anupam Sharma Date & Time:
                Wednesday, 2 October 2024 | 04:00 PM (IST) More ways to join
                meeting • Join using meeting link:
                <a href="https://jiomeetpro.jio.com/shortener?meetingId=0216280862&pwd=f6Ahq">
                  https://jiomeetpro.jio.com/shortener?meetingId=0216280862&pwd=f6Ahq
                </a>
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/25.png"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                26. World GIS day 18 November 20924
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/26.png"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                27. Survival through ages 28 January 2025
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/27.png"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                28. World Wetland Day 3 february 2025 Government Highschool,
                Aghanashini
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/28.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                29. Silver Jubilee of Environmental Education programmes - Know
                your ecosystem and Johny Biosphere Sessions K K English School,
                Varthur 4 February 2025
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/29.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                30.International Day of action for Rivers. Topic: Do you want
                WATER? Speaker: Dr Vinay S Date: Friday, March 14, 2025 Time:
                4:00 PM - 5:00 PM Meeting Link:{" "}
                <a href="https://jiomeetpro.jio.com/shortener?meetingId=7576708159&pwd=jDc5p">
                  https://jiomeetpro.jio.com/shortener?meetingId=7576708159&pwd=jDc5p
                </a>
                Meeting ID: 757 670 8159 Password: jDc5p
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/30.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                31. World Wildlife Day as part of our LiFEstyle for Environment
                Webinar Series. Topic: WWW - Why Worry about Wildlife Speaker:
                Vrijulal MV Date: Friday, March 7, 2025 Time: 5:00 PM - 6:00 PM
                Join JioMeet Link:{" "}
                <a href="https://jiomeetpro.jio.com/shortener?meetingId=5207450634&pwd=qtjQ5">
                  https://jiomeetpro.jio.com/shortener?meetingId=5207450634&pwd=qtjQ5
                </a>
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/31.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                32. International Seagrass Day & international Women day Sowing
                the Seeds of Sustainability: Seagrass Conservation and Coastal
                Women’s Economic Empowerment Speaker: Dr Deepthi Hebbale Date:
                Saturday, March 8, 2025 Time: 4:00 PM - 5:00 PM Meeting Link:{" "}
                <a href=" https://jiomeetpro.jio.com/shortener?meetingId=8315451867&pwd=NzK7S">
                  {" "}
                  https://jiomeetpro.jio.com/shortener?meetingId=8315451867&pwd=NzK7S
                </a>
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/32.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                33. International Forest Day - LiFE Webinar : " Restoring the
                Lost Homes for the Spirits of the Forests " by Dr MD Subash
                Chandran on 21 March 2025 Topic: Restoring the Lost Homes for
                the Spirits of the Forests Speaker: Dr MD Subash Chandran Date:
                Friday, March 21, 2025 Time: 5:00 PM To join the webinar, please
                use the following details: Meeting Link:{" "}
                <a href=" https://jiomeetpro.jio.com/shortener?meetingId=1046437238&pwd=exy3M">
                  {" "}
                  https://jiomeetpro.jio.com/shortener?meetingId=1046437238&pwd=exy3M
                </a>
                Meeting ID: 104 643 7238 Password: exy3M
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/33.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
              </td>
            </tr>

            <tr>
              <td style={{ textAlign: "center" }}>
                34. Application of Geo-informatics in Agriculture Water Resource
                Speaker: Dr Chandan MC Topic 2: Bangalore Lakes for Water
                Sustainability Speaker: Abhishek bagel Date: Saturday, March 22,
                2025 Time: 4:00 PM To join the webinar, please use the following
                details: Meeting Link:{" "}
                <a href=" https://jiomeetpro.jio.com/shortener?meetingId=9041764048&pwd=6CBjU">
                  {" "}
                  https://jiomeetpro.jio.com/shortener?meetingId=9041764048&pwd=6CBjU
                </a>
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/34.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: "center" }}>
                35. World Atmosphere day - Atmospheric wellbeing : Carbon
                Capture, utilization and storage(CCUS) and Beyond
                <br />
                Speaker: Dr Durga Madhab Mahapatra Date: 16th April, 2025 Time:
                4:00 PM To join the webinar, please use the following details:
                Meeting Link:{" "}
                <a href="https://shorturl.at/ZE5wS">
                  {" "}
                  https://shorturl.at/ZE5wS
                </a>
              </td>
              <td style={{ textAlign: "center" }}>
                <p>
                  <p style={{ textAlign: "center" }}>
                    <img
                      style={{ height: 300, width: 500 }}
                      src="images/webinar/35.jpg"
                      alt="Sorry, not found"
                    />
                  </p>
                </p>
              </td>
            </tr>
          </table>
        </p>
      }
    />
  );
}

export default WebinarsPage;
